module.exports = {
    "": "",
    "Menu mobile": "",
    "Logout": "",
    "Choose a destination": "",
    "Where You're Staying": "",
    "Loading": "",
    "Customize your experience": "",
    "Home": "",
    "Transfers": "",
    "All Tours": "",
    "Trending & Reviews": "",
    "Specials": "",
    "Wish List": "",
    "Dining": "",
    "Shopping": "",
    "Contact": "",
    "My Account": "",
    "Tours": "",
    "Get to your hotel with style, select or search your hotel to get our best selection of airport-hotel transfer services. Air conditioned comfortable coaches, minivans or private vehicles will be waiting to take you to your destination.": "",
    "Select your hotel": "",
    "Please select your hotel from the list of available options so we can provide an accurate list of transfer options for your location.": "",
    "Select Airport Option": "",
    "Arrival Airport": "",
    "Departure Airport": "",
    "Select Below": "",
    "Note:": "",
    "If the system shows arrival & departure but round trip is not available, it means that they have to be booked separately.": "",
    "TRANSFERS FOUND:": "",
    " Loading...": "",
    "Loading...": "",
    "Type your Hotel Name": "",
    "Need help?": "",
    "About": "",
    "Privacy Policy": "",
    "About us": "",
    "Account": "",
    "Terms and condition": "",
    "Discover": "",
    "Wishlist": "",
    "Settings": "",
    "Tours Reviews": "",
    "Terms & Conditions": "",
    "Special Offers": "",
    "Empty Cart": "",
    "CHECKOUT": "",
    "We make good vacations great": "",
    "PLACE YOUR ORDER": "",
    "Search Tours": "",
    "Search terms": "",
    "Type your search terms": "",
    "Destination": "",
    "Search Transfers": "",
    "Select": "",
    "Search now": "",
    "Hotel Name": "",
    "CHANGE": "",
    "Seleccione": "",
    "NOT CERTAIN": "",
    "ALL AREAS": "",
    "No Hotels found": "",
    "Select Arrival Airport": "",
    "Rates are per": "",
    "in": "",
    "DESCRIPTION": "",
    "ARRIVAL ONLY": "",
    "(NOT AVAILABLE)": "",
    "ROUND TRIP": "",
    "DEPARTURE ONLY": "",
    "NOT AVAILABLE": "",
    "WELCOME": "",
    "TO": "",
    "<span class='orange_t'>TOUR</span><span class='blue_t'> REVIEWS</span>": "",
    "See What's Hot And What Other vacations have to say": "",
    "See Tours": "",
    "Read Reviews": "",
    "\"...the Royal Swim was perfect for us ...<br />we wanted a great experience and we got it... \"": "",
    "BUY 2 Tours AND GET a 3<sup>rd</sup> ONE FREE": "",
    "<span class='orange_t'>GET</span><span class='yellow_t'> THE</span><span class='blue_t'> APP</span>": "",
    "<span class='orange_t'>FREE</span><span class='blue_t'> TOUR</span>": "",
    "See How!": "",
    "Vacation Offers & Features": "",
    "Download Now!": "",
    "\"FREE CALLS to the concierge before & during vacation<br />Transfers, Tours, and more!\"": "",
    "AIRPORT TRANSFERS ~ GET TO YOUR HOTEL IN STYLE!": "",
    "Our <span class='blue_text'>Destinations</span>": "",
    "Discover our Top tours <span>now</span>": "",
    "Know our places and be happy": "",
    "See our best tour places at Totoura": "",
    "Read more": "",
    "Some <span class='blue_text'>good</span> reasons": "",
    "VACATIONER REVIEWS": "",
    "We have the best reasons to travel": "",
    "Products & Prices Guaranteed!": "",
    "FROM": "",
    "From": "",
    "Details": "",
    "Review": "",
    "Add Cart": "",
    "Add to wishlist": "",
    "Top Rated": "",
    "Delete from wishlist": "",
    "Searching": "",
    "Click on tours you like to build a Wish List": "",
    "Tour & ACTIVITES in": "",
    "We will look for specials and enter you to win your favorites": "",
    "Find your Perfect Tour:": "",
    "By Category": "",
    "3rd Tour Free": "",
    "Land": "",
    "Type your search keyword here & press enter key...": "",
    "Water": "",
    "Cultural": "",
    "Nightlife": "",
    "Adventure": "",
    "Family": "",
    "Select All": "",
    "Unselect All": "",
    "founds": "",
    "Valid 3rd Tour Free": "",
    "Searching...": "",
    "Detail": "",
    "No results found...": "",
    "Name": "",
    "Be in Touch": "",
    "Enter Name": "",
    "Contact Us!": "",
    "\"Enter Email\"": "",
    "Email": "",
    "Message": "",
    "Write your message": "",
    "USA / CANADA": "",
    "Submit": "",
    "CANCUN / COZUMEL PUERTO VALLARTA / LOS CABOS": "",
    "Toll Free": "",
    "DOMINICAN REPUBLIC": "",
    "PUNTA CANA": "",
    "For inquiries please email us at": "",
    "or simply fill out the online contact form": "",
    "PUERTO PLATA": "",
    "Enter your name": "",
    "Enter a valid email": "",
    "Enter your Message - More than 20 characters": "",
    "Arrival": "",
    "Departure": "",
    "Round": "",
    "translate test": "",
    "By agreeing to the Conditions of Use of Totoura?s websites and/or mobile applications Customer agrees to the collection, use and disclosure of its personal information as outlined above.   To the extent provided by applicable law, Customer may request access and correction of its personal information held by TOTOURA by contacting it at the email address set out above.": "",
    "Every individual or legal entity (hereafter referred to as the ?Customer?) by the mere fact of accessing, visiting or registering himself/herself in the Web Site, is automatically subject to the present terms and conditions, as well as to its future modifications. The Customer hereby declares and warrants that he/she is over 18 years of age and has the legal capacity and attributions necessary to purchase or hire in his/her own capacity or in behalf of the legal entity that the Customer declares to represent, as well as to order the charges to the credit card which information he/she provides. The parents and tutors are responsible for the purchases or reservations on-line that are made by the children under their responsibility, with or without their prior approval.": "",
    "Cancunp": "",
    " on or off.": "",
    "Turn ": "",
    "Find and tap ": "",
    "Location": "",
    "Destiny": "",
    "Choose the option you want as your default setting.": "",
    "Location ": "",
    "Chrome.": "",
    "At the bottom, click": "",
    "On your iPhone or iPad, open the settings app.": "",
    "Change your default location settings": "",
    "Site settings ": "",
    "Coming Soon": "",
    "No": "",
    "Recordar Selección": "",
    "¿Desea utilizar su ubicacion actual como destino?": "",
    "Yes": "",
    "Type your City": "",
    "On your computer, open Chrome.": "",
    " Location.": "",
    "What destination do you want to visit?": "",
    "Find your next experience": "",
    "USA": "",
    "Cookies Policy": "",
    "Ask before accessing ": "",
    "Airport - Hotel Transfer Services": "",
    "Location.": "",
    "At the top right, click More ": "",
    " Advanced.": "",
    "Android": "",
    "Let a site know your location": "",
    "on or off.": "",
    "Computer": "",
    "If you use Google as your default search engine on your phone, your location is used by default for your searches on Google.": "",
    " Settings": "",
    "By default, Chrome asks you when a site wants to see your location. To let the site know where you are, choose Allow. Before sharing your location, review the site's privacy policy.": "",
    " Settings.": "",
    "Your Cart": "",
    "No Destination found": "",
    "Site settings.": "",
    "On your Android phone or tablet, open the Chrome app ": "",
    "Tap ": "",
    "Your details": "",
    "Under \"Privacy and security,\" click ": "",
    "iPhone & iPad": "",
    "Click ": "",
    "We'd love to hear from you.": "",
    "To the right of the address bar, tap More ": "",
    "Payment": "",
    "All Destinations": "",
    "NO RETURNS, CHANGES OR CANCELLATIONS ARE ALLOWED": "",
    "Highest Price": "",
    "Range Prices": "",
    "The Free Tour is the one of equal or lesser value to the others and your savings is automatically calculated and shown at checkout just before you finalize your purchase online. Or, you may contact us to make your reservation on phone, we will review the pricing and details with you when we make your booking.": "",
    "<strong>Book 3 Different Tours - ALL MUST BE FROM THOSE LISTED AND SHOWN AS \"Valid 3<sup class=\"t_low\">rd</sup> Tour Free\" on the promotion page.</strong>": "",
    "Filters": "",
    "ALL participants on the reservation must be doing the exact same 3 tours...otherwise, make separate reservations when the selections vary by participant.": "",
    "FILTERS": "",
    "<strong>3<sup class='t_low'>rd</sup> Tour FREE!</strong>": "",
    "3<sup>rd</sup> Tour FREE!": "",
    "<strong>Here's How 3<sup class='t_low'>rd</sup> Tour Free Promo Works</strong>": "",
    "All": "",
    "FILTER BY": "",
    "IMPORTANT RULES/RESTRICTIONS": "",
    "SEE ALL 3<sub class='t_low'>rd</sub> Tour FREE Activities": "",
    "BOOK ALL 3 TOURS in ONE Reservation through the shopping cart.": "",
    "Only the valid displayed <span class=\"blue_text\"><strong>\"3<sup class=\"t_low\">rd</sup> Tour Free\" </strong></span> activities shown online are valid in this promotion. The promotion rules are for a \"set-offer\" as described, and once booked.": "",
    "Activity type": "",
    "ORDER BY": "",
    "NOTE:": "",
    "No tours found": "",
    "Shorter Duration": "",
    "Longer Duration": "",
    "Filter": "",
    "What you are looking?": "",
    "Lowest Price": "",
    "Tours found": "",
    "All listed prices include taxes": "",
    "Ver más": "",
    "See All Experiences": "",
    "Only on {{brandname}}!": "",
    "SEE NOW!": "",
    "See our best tour places at {{brandname}}": "",
    "You won't find it cheaper online or anywhere else!": "",
    "Our providers are hand-picked, safe and reliable, so you always get what you pay for.": "",
    "Why <span class='blue_text'>book ahead</span>?": "",
    "Most <br />Popular <br /> Tours": "",
    "Don't be disappointed": "",
    "The best <br />Water Tours": "",
    "Save time & money": "",
    "When you book ahead, you are guaranteed not to miss out on popula tours & activities.": "",
    "Travel with confidence": "",
    "México & the Caribbean": "",
    "from": "",
    "Cart": "",
    "Store": "",
    "Checkout": "",
    "MEXICO": "",
    "Experiences": "",
    "All Experiences": "",
    "Enter Your Email": "",
    "Language": "",
    "Go": "",
    "Need help with experiences?": "",
    "To add this tour to your wish list  you must log in": "",
    "Login": "",
    "Booking": "",
    "Limited availability": "",
    "There are 24 hours left with this rate": "",
    "Our Vacation Concierge is available.": "",
    "{{qty}} people booked in the last 24 hours": "",
    "Booked {{qty}} times in the last 6 hours": "",
    "Weekend preference, high demand": "",
    "Only {{qty}} tickets of this type are available in {{brandname}}": "",
    "OFFER": "",
    "Everyday from 9:00am to 6:00pm Central": "",
    "There are {{qty}} more users watching this activity": "",
    "This activity is ready to close due to space limit": "",
    "Special sale": "",
    "Booked {{qty}} times in the last 24 hours": "",
    "Rules & Things": "",
    "Activity Date": "",
    "Persons": "",
    "Children ({{minage}}+) Adult Price": "",
    "Children under ({{minage}}) are not allowed": "",
    "Rates are per {{pricetype}} in {{currency}}": "",
    "Select Adults": "",
    "Time": "",
    "Coupon Code": "",
    "Adults": "",
    "Children": "",
    "Date": "",
    "Select Children": "",
    "Validate Coupon": "",
    "TOTAL": "",
    "Check out now": "",
    "Last minute offer": "",
    "Valid 3rd Experience Free": "",
    "Only {{qty}} places left": "",
    "Book online <span class=\"blue_text\">or call</span>": "",
    "PEOPLE ALSO LIKE": "",
    "Highlights": "",
    "Experience Description": "",
    "High demand we have few places": "",
    "Add to Cart": "",
    "We have only {{qty}} tickets": "",
    "Map": "",
    "Our Vacation Concierge is available Everyday from 9:00am to 6:00pm Central Time, to answer your questions.": "",
    "No experiences found": "",
    "mexicofooter": "",
    "<strong>3<sup class='t_low'>rd</sup> Experience FREE!</strong>": "",
    "3<sup>rd</sup> Experience FREE!": "",
    "Experience & ACTIVITES in": "",
    "3rd Experience Free": "",
    "The Free Experience is the one of equal or lesser value to the others and your savings is automatically calculated and shown at checkout just before you finalize your purchase online. Or, you may contact us to make your reservation on phone, we will review the pricing and details with you when we make your booking.": "",
    "ALL participants on the reservation must be doing the exact same 3 experiences...otherwise, make separate reservations when the selections vary by participant.": "",
    "SEE ALL 3<sub class='t_low'>rd</sub> Experience FREE Activities": "",
    "Only the valid displayed <span class=\"blue_text\"><strong>\"3<sup class=\"t_low\">rd</sup> Experience Free\" </strong></span> activities shown online are valid in this promotion. The promotion rules are for a \"set-offer\" as described, and once booked.": "",
    "BOOK ALL 3 EXPERIENCES in ONE Reservation through the shopping cart.": "",
    "<strong>Here's How 3<sup class='t_low'>rd</sup> Experience Free Promo Works</strong>": "",
    "Navigation": "",
    "We are a company focused on providing the best customer experience through our family of ambassadors and our algorithms that allow us to sell, commission and monitor in an interactive way.": "",
    "<strong>Book 3 Different Experiences - ALL MUST BE FROM THOSE LISTED AND SHOWN AS \"Valid 3<sup class=\"t_low\">rd</sup> Experience Free\" on the promotion page.</strong>": "",
    "Explore": "",
    "Explore <br /> the seabed": "",
    " The Best <span class=\"blue_text\"><b>activities for you</b></span>": "",
    " The Best <span class=\"blue_text\">Experiences</span>": "",
    "Drive and dare <br /> to travel the best roads": "",
    "Dinner and <br /> have a quiet evening": "",
    " The Best <br/>Experiences": "",
    "Live  <br /> and cultivate": "",
    "Enjoy <br /> the best environment": "",
    "Discover the most outstanding": "",
    "When you book ahead, you are guaranteed not to miss out on popula experiences & activities.": "",
    "Quick booking": "",
    " The most <br/>Popular": "",
    "Discover and plan your trip": "",
    "Excitement <br /> to the fullest": "",
    "Master <br /> your skills": "",
    "Welcome to <span class=\"blue_text\"><b>{{brandname}}</b></span>, the best place where we give you the best experiences. Explore our destinations and discover the options we have for you.": "",
    " Why should <span class=\"blue_text\"><b>you choose us</b></span>": "",
    "Dare to have <br /> an extreme adventure": "",
    "Family <br /> fun": "",
    "Dive and learn <br /> about the best of the ocean": "",
    "Know the best <br /> of our culture": "",
    "Have a magical  <br /> and unique adventure": "",
    "Reviews": "",
    "Transportation Included from Hotel": "",
    "Tour Description": "",
    "Child": "",
    "Children Ages": ""
}